<template>
  <div>
    <div class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            <span v-if="$route.name === 'users'">
                Users
            </span>
            <span v-if="$route.name !== 'users' && $route.name.indexOf('user') !== -1">
                <router-link :to="{name: 'users'}">Users</router-link>
                <span>&rarr;</span>
                <span v-if="$route.name === 'user'">
                    {{ currentUser ? currentUser.first_name : '' }}
                    {{ currentUser ? currentUser.last_name : '' }}
                </span>
                <span v-else>New User</span>
            </span>
            <div class="is-pulled-right">
              <router-link :to="{name: 'user-create'}" class="button is-primary">
                Create User
              </router-link>
            </div>
          </h1>
        </div>
      </div>
    </div>
    <div class="container">

      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  methods: {
  },
  data() {
    return {
    }
  },
  computed: Object.assign({}, mapGetters(['users']), {
    currentUser() {
      return this.users.find(user => user.id === parseInt(this.$route.params.id))
    },
  })
};
</script>



// WEBPACK FOOTER //
// Users.vue?2378584b